import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTariffs } from 'app/entities/tariff/tariff.reducer';
import { ContractType } from 'app/shared/model/enumerations/contract-type.model';
import { Variant } from 'app/shared/model/enumerations/variant.model';
import { CommercialBusiness } from 'app/shared/model/enumerations/commercial-business.model';
import { createEntity, getEntity, reset, updateEntity } from './tariff-history.reducer';

export const TariffHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tariffs = useAppSelector(state => state.tariff.entities);
  const tariffHistoryEntity = useAppSelector(state => state.tariffHistory.entity);
  const loading = useAppSelector(state => state.tariffHistory.loading);
  const updating = useAppSelector(state => state.tariffHistory.updating);
  const updateSuccess = useAppSelector(state => state.tariffHistory.updateSuccess);
  const contractTypeValues = Object.keys(ContractType);
  const variantValues = Object.keys(Variant);
  const commercialBusinessValues = Object.keys(CommercialBusiness);

  const handleClose = () => {
    navigate('/tariff-history');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTariffs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.tariff !== undefined && typeof values.tariff !== 'number') {
      values.tariff = Number(values.tariff);
    }
    if (values.supplierId !== undefined && typeof values.supplierId !== 'number') {
      values.supplierId = Number(values.supplierId);
    }

    const entity = {
      ...tariffHistoryEntity,
      ...values,
      tariffType: tariffs.find(it => it.id.toString() === values.tariffType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          contractType: 'FIXED',
          variant: 'STANDARD',
          commercialBusiness: 'ONE_YEAR',
          ...tariffHistoryEntity,
          tariffType: tariffHistoryEntity?.tariffType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.tariffHistory.home.createOrEditLabel" data-cy="TariffHistoryCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.tariffHistory.home.createOrEditLabel">
              Create or edit a TariffHistory
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tariff-history-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.tariffHistory.tariff')}
                id="tariff-history-tariff"
                name="tariff"
                data-cy="tariff"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.tariffHistory.effectiveDate')}
                id="tariff-history-effectiveDate"
                name="effectiveDate"
                data-cy="effectiveDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.tariffHistory.expirationDate')}
                id="tariff-history-expirationDate"
                name="expirationDate"
                data-cy="expirationDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.tariffHistory.supplierId')}
                id="tariff-history-supplierId"
                name="supplierId"
                data-cy="supplierId"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.tariffHistory.contractType')}
                id="tariff-history-contractType"
                name="contractType"
                data-cy="contractType"
                type="select"
              >
                {contractTypeValues.map(contractType => (
                  <option value={contractType} key={contractType}>
                    {translate(`crawlerBackendApp.ContractType.${contractType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.tariffHistory.variant')}
                id="tariff-history-variant"
                name="variant"
                data-cy="variant"
                type="select"
              >
                {variantValues.map(variant => (
                  <option value={variant} key={variant}>
                    {translate(`crawlerBackendApp.Variant.${variant}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.tariffHistory.commercialBusiness')}
                id="tariff-history-commercialBusiness"
                name="commercialBusiness"
                data-cy="commercialBusiness"
                type="select"
              >
                {commercialBusinessValues.map(commercialBusiness => (
                  <option value={commercialBusiness} key={commercialBusiness}>
                    {translate(`crawlerBackendApp.CommercialBusiness.${commercialBusiness}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="tariff-history-tariffType"
                name="tariffType"
                data-cy="tariffType"
                label={translate('crawlerBackendApp.tariffHistory.tariffType')}
                type="select"
              >
                <option value="" key="0" />
                {tariffs
                  ? tariffs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.type}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/tariff-history"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TariffHistoryUpdate;
